// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How a command acknowledgement turned out.
 *
 * Carried on [`FrontEndMessage`] rather than as its own message type because a
 * verdict is provenance — the same kind of annotation as `derived` — not a new
 * kind of device state. `None` is the value every message that is not an
 * acknowledgement carries, which is almost all of them, so it must be the zero.
 */
export enum AckOutcome {
  /**
   * Not an acknowledgement. The default, and what every ordinary telemetry
   * message carries.
   */
  None = 0,

  /**
   * The controller answered the command this message reports.
   */
  Matched = 1,

  /**
   * The controller answered something nothing was waiting for. Worth surfacing
   * rather than swallowing: it means a request was sent that the correlator
   * never saw, or the controller answered twice.
   */
  Unsolicited = 2,

  /**
   * The command was never answered inside its window.
   */
  Expired = 3,

  /**
   * VTS did not send the command at all: a channel modifier's gate with
   * `timeout_policy` DROP failed — the interlock it waits on did not confirm,
   * or its payload could not be delivered. The message carries the command
   * that was held back; it is not device state and must not be applied as such.
   */
  Withheld = 4,

  /**
   * Not an acknowledgement: a progress report of the channel-modifier sequence
   * run the commanded message started. The message carries that command (bank,
   * lift, leaf, floor) and the run's state in `sequence`; it is not device
   * state and must not be applied as such. A reader that does not know this
   * value would apply the command as state, so it must be understood; one that
   * does skips just these messages.
   */
  SequenceProgress = 5,
}
